// Renders 1–2 relationship badges for an event.
// relationship: "hosting" | "hosted" | "attending" | "attended" | "maybe" | null
// rsvpStatus:   the host's own RSVP status — only used when relationship is "hosting"/"hosted"
//               to produce a second badge (e.g. "Hosting" + "Maybe")

const STYLES = {
  hosting:   "bg-primary/10 text-primary",
  hosted:    "bg-primary/10 text-primary",
  attending: "bg-green-500/10 text-green-700 dark:text-green-400",
  attended:  "bg-green-500/10 text-green-700 dark:text-green-400",
  maybe:     "bg-yellow-500/10 text-yellow-700 dark:text-yellow-400",
  waitlisted:"bg-orange-500/10 text-orange-700 dark:text-orange-400",
};

const LABELS = {
  hosting: "Hosting", hosted: "Hosted",
  attending: "Attending", attended: "Attended",
  maybe: "Maybe", waitlisted: "Waitlisted",
};

function Chip({ type, className = "" }) {
  const style = STYLES[type] ?? "bg-muted text-muted-foreground";
  const label = LABELS[type] ?? type;
  return (
    <span className={`shrink-0 text-xs px-2 py-0.5 rounded-full font-medium ${style} ${className}`}>
      {label}
    </span>
  );
}

export function EventBadge({ relationship, rsvpStatus = null }) {
  if (!relationship) return null;

  const isHost = relationship === "hosting" || relationship === "hosted";

  // Hosting + maybe → two chips
  if (isHost && rsvpStatus === "maybe") {
    return (
      <div className="flex items-center gap-1 shrink-0">
        <Chip type={relationship} />
        <Chip type="maybe" />
      </div>
    );
  }

  return <Chip type={relationship} />;
}
